import React, { useEffect, useRef, useState } from "react";
import Footer from "../../components/footer/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import { addToList, showListing } from "../../features/listingSlice";
import NavbarComponent from "../../components/navbar/NavbarComponent";
import "./Listing.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { API, SEARCH_API } from "../../constants/Api";
import { toast } from "react-toastify";
import Meta from "../../components/Meta";
import { titleCase } from 'title-case';
function Listing() {
  const [placeHolder, setPlaceHolder] = useState(
    "Search using zip codes, City, State or property address"
  );

  const navigate = useNavigate();
  const [showSearchHistory, setSearchHistory] = useState(false);
  const [query, setQuery] = useState("");
  const dispatch = useDispatch();
  const listingItems = useSelector((state) => state.listing.listingItems);

  // const [zip, setZip] = useState("90017");
  const location = useLocation();
  const { data } = location.state || {};
  const { zipcode } = location.state || "";
  const [sliceHouses, setSliceHouses] = useState(6);
  const [loading, setLoading] = useState(false);
  const btRef = useRef(null);
  const userId = localStorage.getItem("userId");
  const [favoriteHouses, setFavoriteHouses] = useState([]);

  const addFavouriteHouse = async (
    houseAddress,
    zipcode,
    images,
    price,
    houseLink
  ) => {
    const toastId = toast.loading("adding in fvrt...");
    try {
      if (userId) {
        const numericPrice = parseInt(price.replace(/[^0-9]/g, ""), 10) || 0;
        const response = await fetch(`${API}/user/toggle-bookmark`, {
          method: "POST",
          body: JSON.stringify({
            userId: userId,
            address: houseAddress,
            zipCode: zipcode,
            images: images,
            price: numericPrice,
            link: houseLink,
          }),
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response.ok) {
          setFavoriteHouses((prevFavorites) =>
            prevFavorites.some((fav) => fav.address === houseAddress)
              ? prevFavorites.filter((fav) => fav.address !== houseAddress)
              : [...prevFavorites, houseAddress]
          );
          toast.update(toastId, {
            render: "Added to your Bookmarks...",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
        }
      } else {
        toast.update(toastId, {
          render: "You have to log in...",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
        setTimeout(() => {
          navigate("/user-register");
        }, 200);
      }
    } catch (error) {
      toast.update(toastId, {
        render: "Network error",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  const handleFocus = () => {
    console.log("hi");
    setPlaceHolder("");
    setSearchHistory(true);
    document.getElementById("zip-listing-search-button").style.borderRadius =
      "0px 10px 10px 0px";
  };

  const handleSearchClick = async () => {
    if (!query.trim()) {
      toast.error("Please enter a valid query.");
      return;
    }
    setSearchHistory(false);
    setLoading(true);
    try {
      const response = await fetch(SEARCH_API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query }),
      });

      const json = await response.json();
      if (response.ok) {
        if (!listingItems.includes(query.toLowerCase())) {
          dispatch(addToList(query.toLowerCase()));
        }

        // const isZipCode = /^\d{5}$/.test(query.trim());
        navigate(json.listing ? "/zipcode-listing" : "/listing-detail", {
          state: { data: json.houses, zipcode: json.listing ? query : undefined },
        });
      } else {
        toast.error(json.error || "Something went wrong. Try again.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSectionClick = () => {
    setSearchHistory(false);
  };

  const handleHistortyClick = (newQuery) => {
    setQuery(newQuery);
    setSearchHistory(false);
  };

  const loadMore = () => {
    setSliceHouses(sliceHouses + 6);
  };

  const toDetailPage = async (query) => {
    const toastId = toast.loading("Loading details...");
    const data = "https://www.redfin.com" + query;
    const response = await fetch(SEARCH_API, {
      method: "POST",
      body: JSON.stringify({ query: data }),
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      const json = await response.json();

      if (json.error) {
        toast.update(toastId, {
          render: "Error! Try again later.",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        toast.update(toastId, {
          render: "Successfully loaded!",
          type: "success",
          isLoading: false,
          autoClose: 3000,
        });
        navigate("/listing-detail", { state: { data: json.houses } });
      }
    }
  };
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      if (btRef) {
        btRef.current.click();
      }
    }
  };
  return (
    <>
      <Meta 
        title={`${titleCase(zipcode)} - Homes For Sale | DDH`} 
        description={`Deal Direct Homes has ${data?.length} homes for sale in ${titleCase(zipcode)}. View listing photos, and use our detailed home buying filters to find the perfect place.`}
      />
      <div className="zip-listing-section" onClick={handleSectionClick}>
        <NavbarComponent />

        <div className="container-fluid listing-container" style={{ paddingBottom: "120px" }}>
        <div className="row px-0 mx-0 listing-page-add">
            <div className="col-12 px-0 mx-0">
              <img
                src="/img/detail-page-add.svg"
                className="img-fluid detail-page-add-image"
                alt=""
                onClick={()=>{navigate("/advertiser-register")}}
                style={{cursor: "pointer"}}
              />
            </div>
          </div>
          <div className="row px-0 mx-0">
            <div
              id="search-container-2"
              className={`col-12 d-flex justify-content-center ${isMobile ? "p-0" : ""}`}
            >
              <div className="row w-100">
                <div
                  className={`col-12 d-flex justify-content-center ${isMobile ? "p-0" : ""}`}
                >
                  <div
                    className="input-group zip-listing-input-group mb-3 position-relative"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <button
                      className="btn zip-listing-search-icon"
                      type="button"
                    >
                      <img
                        src="/img/gold-search-icon.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </button>
                    <input
                      onFocus={handleFocus}
                      onBlur={() =>
                        setPlaceHolder("Search using zip codes, City, State or property address")
                      }
                      type="text"
                      className="form-control zip-listing-input"
                      placeholder={placeHolder}
                      aria-label="Recipient's username"
                      aria-describedby="button-addon2"
                      onChange={(e) => setQuery(e.target.value)}
                      value={query}
                      onKeyDown={handleKeyDown} // Detect Enter key
                    />
                    {/* <button
                      onClick={handleSearchClick}
                      className="btn zip-listing-search-button"
                      type="button"
                      id="zip-listing-search-button"
                    >
                      <img
                        src="/img/dark-vector.svg"
                        className="img-fluid"
                        alt=""
                      />
                    </button> */}
                    {loading ? (
                      <button
                        className={`btn zip-listing-search-button`}
                        type="button"
                        id="zip-listing-search-button"
                      >
                        <span
                          className="spinner-border text-white"
                          style={{ height: "14px", width: "14px" }}
                        ></span>
                      </button>
                    ) : (
                      <button
                        onClick={handleSearchClick}
                        className={`btn zip-listing-search-button`}
                        type="button"
                        id="zip-listing-search-button"
                        ref={btRef}
                      >
                        <img
                          src="/img/Vector.svg"
                          className="img-fluid"
                          alt=""
                        />
                      </button>
                    )}

                    {loading ? (
                      <div className="col-12 d-flex justify-content-start mt-2">
                        <span className="text-white collecting-data-text">
                          Collecting Data...
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                    {showSearchHistory && listingItems.length > 0 ? (
                      <div className="col-12 d-flex justify-content-center zip-listing-search-history-column">
                        <div className="zip-listing-search-result-group">
                          {listingItems.slice(-3).map((item, index) => (
                            <div
                              role="button"
                              onClick={() => handleHistortyClick(item)}
                              className="zip-listing-search-result-item w-100 text-start d-flex align-items-center gap-3"
                              key={index}
                            >
                              <i
                                className="bi bi-clock-history"
                                style={{ fontSize: "13px" }}
                              ></i>{" "}
                              {item}
                            </div>
                          ))}
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row px-0 mx-0">
            <div className="col-12 px-0 zip-listing-h1-container">
              <span className="zip-listing-h1">
                Showing Results for “{titleCase(zipcode)}”
              </span>
            </div>
          </div>
          <div className="row px-0 mx-0 py-3">
            {data?.slice(0, sliceHouses).map((house, index) => (
              <div
                className={`col-lg-4 py-2 ${isMobile ? "px-0" : ""}`}
                key={index}
              >
                <div className={`zip-listing-card-column ${isMobile? "p-2": "p-4"}`}>
                  <div
                    className="card zip-listing-card"
                    style={{ cursor: "pointer", position: "relative" }}
                  >
                    {
                      userId?
                      <img
                      className="top-right-image"
                      src={
                        favoriteHouses.some((fav) => fav == house?.address)
                          ? "/img/un-fav.svg"
                          : "/img/un-fav.svg"
                      }
                      onClick={() =>
                        addFavouriteHouse(
                          house?.address,
                          zipcode,
                          house?.image,
                          house?.price,
                          house?.link
                        )
                      }
                    />
                    :
                    <></>
                    }
                
                    <img
                      onClick={() => toDetailPage(house?.link)}
                      src={
                        house?.image?.length > 1
                          ? house?.image[1]
                          : house?.image[0]
                      }
                      className="card-img-top zip-listing-card-image"
                      alt="Hollywood Sign on The Hill"
                    />
                    <div
                      className="card-body zip-listing-card-body pb-0"
                      onClick={() => toDetailPage(house?.link)}
                    >
                      <h5 className="card-title zip-listing-card-title">
                        {house?.price}
                      </h5>
                      <div className="container-fluid px-0">
                        <div className="row px-0 mx-0">
                          <div className="col-md-12 col-lg-12 col-xl-12 col-xxl-5 px-0">
                            <span className="zip-listing-card-address">
                              {house?.address}
                            </span>
                          </div>
                          <div className="col-md-12 col-lg-12 col-xl-12 col-xxl-7 px-0 zip-listing-card-menus-container d-flex align-items-center">
                            <div className="row px-0 mx-0 w-100">
                              {isMobile ? (
                                <>
                                  <div className="col-4 zip-listing-card-menus px-0 d-flex justify-content-start align-items-center">
                                    <img
                                      src="/img/border_all.svg"
                                      className="img-fluid"
                                      style={{ height: "17px" }}
                                      alt=""
                                    />
                                    &nbsp;&nbsp;
                                    <span
                                      className="text-center"
                                      style={{ lineHeight: "1" }}
                                    >
                                      {house?.sq_ft || "- sq ft"}
                                    </span>
                                  </div>
                                  <div className="col-4 zip-listing-card-menus px-0 d-flex justify-content-start align-items-center">
                                    <img
                                      src="/img/local_hotel.svg"
                                      className="img-fluid"
                                      style={{ height: "17px" }}
                                      alt=""
                                    />
                                    &nbsp;&nbsp;
                                    <span
                                      className="text-center"
                                      style={{ lineHeight: "1" }}
                                    >
                                      {house?.beds || "- beds"}
                                    </span>
                                  </div>
                                  <div className="col-4 zip-listing-card-menus px-0 d-flex justify-content-start align-items-center">
                                    <img
                                      src="/img/bathtub.svg"
                                      className="img-fluid"
                                      style={{ height: "17px" }}
                                      alt=""
                                    />
                                    &nbsp;&nbsp;
                                    <span
                                      className="text-center"
                                      style={{ lineHeight: "1" }}
                                    >
                                      {house?.baths || "- baths"}
                                    </span>
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div className="col-xl-4 col-lg-6 col-sm-4 zip-listing-card-menus px-0 d-flex justify-content-end align-items-center">
                                    <img
                                      src="/img/border_all.svg"
                                      className="img-fluid"
                                      style={{ height: "17px" }}
                                      alt=""
                                    />
                                    &nbsp;&nbsp;
                                    <span
                                      className="text-center"
                                      style={{ lineHeight: "1" }}
                                    >
                                      {house?.sq_ft || "- sq ft"}
                                    </span>
                                  </div>
                                  <div className="col-xl-4 col-lg-6 col-sm-4 zip-listing-card-menus px-0 d-flex justify-content-end align-items-center">
                                    <img
                                      src="/img/local_hotel.svg"
                                      className="img-fluid"
                                      style={{ height: "17px" }}
                                      alt=""
                                    />
                                    &nbsp;&nbsp;
                                    <span
                                      className="text-center"
                                      style={{ lineHeight: "1" }}
                                    >
                                      {house?.beds || "- beds"}
                                    </span>
                                  </div>
                                  <div className="col-xl-4 col-sm-4 col-lg-6 zip-listing-card-menus px-0 d-flex justify-content-end align-items-center">
                                    <img
                                      src="/img/bathtub.svg"
                                      className="img-fluid"
                                      style={{ height: "17px" }}
                                      alt=""
                                    />
                                    &nbsp;&nbsp;
                                    <span
                                      className="text-center"
                                      style={{ lineHeight: "1" }}
                                    >
                                      {house?.baths || "- baths"}
                                    </span>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {data?.length > sliceHouses ? (
            <div className="row px-0 mx-0">
              <div className="col-12 d-flex justify-content-center text-center">
                <button className="btn load-more" onClick={loadMore}>
                  Load more
                </button>
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Listing;
